import { createAction } from "@reduxjs/toolkit";

// 2026-10-28 · Badge «cuenta impresa hace X min» (mesa.checkPrintedAt) en el
// dispositivo que actúa, sin esperar al eco del servidor:
//   - imprimir la cuenta lo enciende al instante (como hace el servidor:
//     solo si no estaba ya, y quita «pago solicitado»);
//   - comandar/guardar otra ronda lo apaga (el servidor también lo resetea).
// Acciones aparte (como mesaKicked) para que session/product puedan
// despacharlas sin importar el slice de mesas.
export const mesaCheckPrintedLocally = createAction(
  "mesas/checkPrintedLocally",
  ({ sessionId, mesaId = null, at = new Date().toISOString() }) => ({
    payload: { sessionId: sessionId ?? null, mesaId, at },
  }),
);

/** La impresión falló: se deshace la marca optimista si sigue siendo la nuestra. */
export const mesaCheckPrintedRevert = createAction(
  "mesas/checkPrintedRevert",
  ({ mesaId, at }) => ({ payload: { mesaId, at } }),
);

export const mesaComandadaLocally = createAction("mesas/comandadaLocally", (mesaId) => ({
  payload: { mesaId: mesaId ?? null },
}));
